import React from 'react';
import NavLink from './common/NavLink';
import * as urls from '../actions/urlTypes';
import { PROFILE_INSIGHTS } from '../messages/NavigationMessages'; // Disabling Card nav for MArch release

const EnablementNav = () => {
  return (
    <nav className="nav-dropdown-menu--items">
      <ul className="nav-dropdown-menu--list">
        <li>
          <NavLink to={`${urls.APP_ROOT_URL}/datahub/targets`}>
            Activate Campaign Targets
          </NavLink>
        </li>
        {/* Disabling Card nav for PLAT-17291 */}
        {/* <li>
           <a
            rel="noopener noreferrer"
            target="_blank"
            href={`${urls.APP_ROOT_URL}/v2/datahub/profile`}
          >
            {PROFILE_INSIGHTS}
          </a>
        </li> */}
      </ul>
    </nav>
  );
};


export default EnablementNav;
